import locationGalleryManifest from "@/data/locationGalleryManifest.json";

/** Hero / listing image when API order or manifest sort would be wrong */
const PRIMARY_PHOTO_OVERRIDE = {
  "giant-fitness-voorhees": "/locations/Voorhees/exteriorVoorhees.jpg",
  "giant-fitness-moorestown": "/locations/Moorestown/exteriorMoorestown.jpg",
};

/**
 * Remove duplicate URLs and duplicate filenames (e.g. same file copied under two
 * public/locations/* folders). First occurrence wins.
 */
export function dedupePhotoPathsPreserveOrder(urls) {
  if (!Array.isArray(urls) || urls.length === 0) return [];
  const seenUrls = new Set();
  const seenBasename = new Set();
  const out = [];
  for (const u of urls) {
    if (typeof u !== "string" || !u.trim()) continue;
    const url = u.trim();
    if (seenUrls.has(url)) continue;
    const base = url.split("/").pop().toLowerCase();
    if (base && seenBasename.has(base)) continue;
    seenUrls.add(url);
    if (base) seenBasename.add(base);
    out.push(url);
  }
  return out;
}

/**
 * Prefer the static manifest (all images under public/locations for this club)
 * when present; otherwise use photos from the API.
 */
export function getLocationGalleryPhotos(locationId, apiPhotos) {
  const fromManifest = locationGalleryManifest[locationId];
  if (Array.isArray(fromManifest) && fromManifest.length > 0) {
    return dedupePhotoPathsPreserveOrder(fromManifest);
  }
  return dedupePhotoPathsPreserveOrder(Array.isArray(apiPhotos) ? apiPhotos : []);
}

/**
 * Path for hero + SEO primary image: explicit override, else API first photo, else first manifest image.
 */
export function getPrimaryPhotoPath(locationId, apiPhotos, galleryPhotos) {
  const override = PRIMARY_PHOTO_OVERRIDE[locationId];
  if (override) return override;
  if (apiPhotos?.[0]) return apiPhotos[0];
  return galleryPhotos[0] || null;
}

/**
 * Full gallery order: primary photo first (if known), then remaining manifest/API images.
 */
export function getOrderedGalleryPhotos(locationId, apiPhotos, galleryPhotos) {
  const primary = getPrimaryPhotoPath(locationId, apiPhotos, galleryPhotos);
  if (galleryPhotos.length === 0) {
    if (apiPhotos?.length) return dedupePhotoPathsPreserveOrder([...apiPhotos]);
    return primary ? dedupePhotoPathsPreserveOrder([primary]) : [];
  }
  if (!primary) return dedupePhotoPathsPreserveOrder([...galleryPhotos]);
  const rest = galleryPhotos.filter((p) => p !== primary);
  return dedupePhotoPathsPreserveOrder([primary, ...rest]);
}
